import React, { Component } from 'react'
import styled from 'styled-components'
import bgImage from '../static/images/backgrounds/timeline.jpg'
import { Section } from '../styles/elements'
import SectionHeading from '../components/SectionHeading'
import { colors, media } from '../styles/vars'
import TimelineList from '../components/TimelineList'
import timelineItems from '../data/timeline.json'
import TimelineDetails from '../components/TimelineDetails'
import ReactAudioPlayer from 'react-audio-player'
import throttle from 'lodash.throttle'
import { push } from '../analytics'

const Container = styled(Section) `
min-height:90vh;
background-color:${colors.black};
padding-bottom:20px;
`
const Content = styled.div`
background-image:url(${bgImage});
background-size:cover;
background-position:center;
position:relative;
height:270px;
padding:20px 0;
${
    media.desktop`
    height:910px;
    padding:30px 0;
    `
    }
`
const ListContainer = styled.div`
position:absolute;
bottom:0;
left:0;
right:0;
`
const HeadingContainer = styled.div`
${
    media.desktop`
      text-align:center;
    `
    }
`

const audioFilesPath = './static/timeline_sounds/';
const _generateRandom = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
class TimelineSection extends Component {
    constructor() {
        super();
        this.handlePlayerClick = this.handlePlayerClick.bind(this);
        this.setCarouselNode = this.setCarouselNode.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.handleItemClick = this.handleItemClick.bind(this);
        this.handleItemLoaded = this.handleItemLoaded.bind(this);
        this.pauseAudio = this.pauseAudio.bind(this);
        this.placeCurrentDetails = this.placeCurrentDetails.bind(this);
        this.throttleReposition = throttle(this.placeCurrentDetails, 700);

        this.carouselSettings = {
            infinite: false,
            arrows: false,
            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 6,
            afterChange: this.selectItem,
            responsive: [
                {
                    breakpoint: 320,
                    settings: {
                        centerMode: true,
                        centerPadding: '60px',
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 460,
                    settings: {
                        centerMode: true,
                        centerPadding: '90px',
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 980,
                    settings: {
                        centerMode: true,
                        centerPadding: '150px',
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
            ]
        };
        this.state = {
            items: timelineItems,
            currentItem: {},
            detailsX: 0,
            interacted: false
        }
    }
    componentDidMount() {
        this.selectItem(0);
        window.addEventListener('resize', this.throttleReposition, false);
    }
    componentWillUnmount() {
        window.addEventListener('resize', this.throttleReposition, false);
    }
    selectItem(index) {
        let _items = this.state.items;
        let _activeItem;
        _items.forEach((i, idx) => {
            i.active = index === idx;
            if (i.active) _activeItem = i;
        });
        if (_activeItem === this.state.currentItem) return;

        if (this.state.interacted) push('Years_Navigation', _activeItem.year);

        this.setState({
            interacted: true,
            items: _items,
            currentItem: _activeItem,
            audioPosition: _generateRandom(0, 196)
        }, () => this.placeDetails(_activeItem.node));
        this.pauseAudio();
    }
    handleItemLoaded(index, node) {
        let items = this.state.items;
        let selectedItem = items[index];
        selectedItem.node = node;
        selectedItem.idx = index;
        this.setState({
            items
        });
    }
    handleItemClick(index) {
        this.selectItem(index);
        if (!this.props.isMobile) return;
        setTimeout(() => {
            this.carousel.innerSlider.slickGoTo(index);
        }, 0);
    }
    placeCurrentDetails() {
        this.placeDetails(this.state.currentItem.node);
    }
    placeDetails(node) {
        if (this.props.isMobile) return;
        this.setState({
            detailsX: this.getNodeX(node)
        });
    }
    getNodeX(node) {
        const itemWidth = node.clientWidth;
        const pageWidth = window.document.body.clientWidth;

        if (this.state.currentItem.idx === 0)
            return (-pageWidth + 405);
        if (this.state.currentItem.idx === (this.state.items.length - 1))
            return -5;
        const itemX = node.getBoundingClientRect().x;

        return (
            (-pageWidth) + ((itemX + itemWidth) + 50)
        )
    }
    setCarouselNode(node) {
        this.carousel = node;
    }
    handlePlayerClick() {
        this[this.player.audioEl.paused ? 'playAudio' : 'pauseAudio']();
    }
    playAudio() {
        this.player.audioEl.play();
        this.setState({
            isAudioPlaying: true
        });
        push('Song_Clicked', this.state.currentItem.title);
    }
    pauseAudio() {
        this.player.audioEl.pause();
        if (this.player.audioEl.currentTime)
            this.player.audioEl.currentTime = 0;
        this.setState({
            isAudioPlaying: false
        });
    }
    render() {
        return (
            <Container name="timeline">
                <Content>
                    <HeadingContainer>
                        <SectionHeading
                            title="איך זה התחיל: קיצור תולדות הרעש"
                            subtitle="דרור עמיר"
                            bgColor="rgba(1,202,203,.8)"
                            color={colors.black}
                        />
                    </HeadingContainer>
                    <ListContainer>
                        <TimelineList
                            items={this.state.items}
                            onItemClick={this.handleItemClick}
                            onItemLoad={this.handleItemLoaded}
                            settings={this.carouselSettings}
                            nodeHandler={this.setCarouselNode}
                        />
                    </ListContainer>
                </Content>
                <ReactAudioPlayer
                    src={`${audioFilesPath}${this.state.currentItem.filename}`}
                    ref={node => this.player = node}
                    onEnded={this.pauseAudio}
                />
                <TimelineDetails
                    isAudioPlaying={this.state.isAudioPlaying}
                    title={this.state.currentItem.title}
                    text={this.state.currentItem.text}
                    onPlayerClick={this.handlePlayerClick}
                    audioPosition={this.state.audioPosition}
                    translateX={this.state.detailsX}
                />
            </Container>
        )
    }
}

export default TimelineSection;


// WEBPACK FOOTER //
// ./src/containers/TimelineSection.jsx